import { useMemo } from 'react';

import { LoadingLayout } from 'components';
import { ErrorFallback } from 'modules/App/ErrorFallback';
import { filterVisibleOnboardingStatuses } from 'modules/client/common/helpers/filterVisibleOnboardingStatuses';

import { useClientVersion } from '../hooks';
import { ClientVersionView } from '../views/ClientVersionView';

export const ClientVersionContainer = () => {
  const {
    initialValues,
    loading,
    error,
    versions,
    breadcrumbsTitles,
    client,
    snapshot,
    fullName,
    snapshotLoading,
    versionId,
    hasRepresentative,
    onClickRepresentative,
    onChangeVersion,
    onCloseVersionHistory,
  } = useClientVersion();

  const visibleOnboardingStatuses = useMemo(
    () => filterVisibleOnboardingStatuses(snapshot?.value.onboarding?.statuses),
    [snapshot?.value.onboarding?.statuses]
  );

  if (error) {
    return <ErrorFallback />;
  }

  if (loading) {
    return <LoadingLayout />;
  }

  return (
    <ClientVersionView
      breadcrumbsTitles={breadcrumbsTitles}
      countries={[]}
      currentAccountStatus={snapshot?.value.accountStatus}
      currentOnboardingStatus={snapshot?.value.onboardingStatus}
      fullName={fullName}
      hasRepresentative={hasRepresentative}
      initialValues={initialValues}
      kycData={snapshot?.value.kyc}
      managers={[]}
      representativeInfo={
        snapshot?.value.representative ?? client?.representative
      }
      snapshotLoading={snapshotLoading}
      versionId={versionId}
      versions={versions ?? []}
      visibleOnboardingStatuses={visibleOnboardingStatuses}
      onChangeVersion={onChangeVersion}
      onClickRepresentative={onClickRepresentative}
      onCloseVersionHistory={onCloseVersionHistory}
    />
  );
};
